import { createClient } from '@supabase/supabase-js'

export const leadpinSupabase = createClient(
  import.meta.env.VITE_LEADPIN_SUPABASE_URL,
  import.meta.env.VITE_LEADPIN_SUPABASE_ANON_KEY
)
